import { TFunction } from 'react-i18next';
import { switchUnreachable } from 'common/utils/common';
import { AccountingTableName, TableSection } from 'views/Account/Accounting/types';
import { PaymentMethod } from 'common/types';
import { DepositStatus } from 'views/Rental/SideBar/PaymentSection/DepositSection/utils';
import { ChargeStatus } from 'views/Rental/SideBar/PaymentSection/ChargeSection/utils';

export const getAccountingTableNameTranslation = (tableName: AccountingTableName, t: TFunction) => {
	switch (tableName) {
		case 'bookings':
			return t('reports.accounting.bookings.title2', 'Orders');
		case 'sales':
			return t('reports.accounting.sales.title', 'Sales');
		case 'refunds':
			return t('reports.accounting.refunds.title', 'Refunds');
		case 'fees':
			return t('reports.accounting.fees.title', 'Fees');
		default:
			try {
				switchUnreachable(tableName);
			} catch (err) {}
			return tableName;
	}
};

export const getAccountingTableSectionTranslation = (tableSection: TableSection, t: TFunction) => {
	switch (tableSection) {
		case 'date_breakdown':
			return t('reports.accounting.sections.date_breakdown', 'Date breakdown');
		case 'custom_group_breakdown':
			return t('reports.accounting.sections.custom_group_breakdown', 'Custom group breakdown');
		case 'item_breakdown':
			return t('reports.accounting.sections.item_breakdown', 'Item breakdown');
		case 'method_breakdown':
			return t('reports.accounting.sections.method_breakdown', 'Method breakdown');
		case 'tax_breakdown':
			return t('reports.accounting.sections.tax_breakdown', 'Tax breakdown');
		default:
			try {
				switchUnreachable(tableSection);
			} catch (err) {}
			return tableSection;
	}
};

export const getPaymentMethodTranslation = (method: PaymentMethod, t: TFunction) => {
	switch (method) {
		case 'CARD_TERMINAL':
			return t('common:payments.methods.CARD_TERMINAL', 'Card (terminal)');
		case 'CASH':
			return t('common:payments.methods.CASH', 'Cash');
		case 'INVOICE':
			return t('common:payments.methods.INVOICE', 'Invoice');
		default:
			return method;
	}
};

export const getDepositStatusTranslation = (status: DepositStatus, t: TFunction) => {
	switch (status) {
		case 'charged':
			return t('common:payment.charged', 'Charged');
		case 'unreserved':
			return t('common:payment.unreserved', 'Unreserved');
		case 'reserved':
			return t('common:payment.reserved', 'Reserved');
		case 'refunded':
			return t('common:payment.refunded', 'Refunded');
		case 'cancelled':
			return t('common:payment.cancelled', 'Released');
		case 'pending_capture':
			return t('common:payment.pending_capture', 'Capture pending');
		case 'pending_refund':
			return t('common:payment.pending_refund', 'Refund pending');
		default:
			try {
				switchUnreachable(status);
			} catch (err) {}
			return status;
	}
};

export const getChargeStatusTranslation = (status: ChargeStatus, t: TFunction) => {
	switch (status) {
		case 'paid':
			return t('common:payment.paid', 'Paid');
		case 'unpaid':
			return t('common:payment.unpaid', 'Unpaid');
		case 'overpaid':
			return t('common:payment.overpaid', 'Overpaid');
		case 'refunded':
			return t('common:payment.refunded', 'Refunded');
		case 'pending_refund':
			return t('common:payment.pending_refund', 'Refund pending');
		default:
			try {
				switchUnreachable(status);
			} catch (err) {}
			return status;
	}
};
